
export const blogIndex = (function ($){

    var $DOM = {};


    function init() {
        $DOM.grid = $(".blog-grid");
        if(!$DOM.grid.length) {
            return;
        }

        $DOM.gridItems = $DOM.grid.find(".blog-grid-item");
        $DOM.gridItemsSingle = $DOM.grid.find(".blog-grid-item-single");
        $DOM.gridItemsDouble = $DOM.grid.find(".blog-grid-item-double");

        $DOM.grid.imagesLoaded( function() {
            fixHeight();
            fixGrid();
        });

        $(window).on("resize", function(){
            fixHeight();
        })


    }

    function fixHeight() {

        var winW = $(window).width();
        if(winW > 767) {


            $DOM.gridItemsSingle.css({
                "height": 'auto'
            });
            $DOM.gridItemsDouble.css({
                "height": 'auto'
            });
        }
        else {
            $DOM.gridItemsDouble.css({
                "height": "auto"
            });
            $DOM.gridItemsSingle.css({
                "height": "auto"
            });
        }



    }

    function fixGrid() {
        $DOM.grid.masonry({
            // options
            itemSelector: '.blog-grid-item',
            columnWidth: '.grid-sizer',
            horizontalOrder: true,
            percentPosition: true,


        });

        $DOM.grid.addClass("is-loaded");
    }

    return {
        init: init
    }

})(jQuery);
